import {
  GetRecommendationsSummaryResponse,
  GetRecommendationsTopItemsResponse,
  GetRecommendationsAverageBasketValueResponse,
} from '../reports-service.types';

export const recommendationsSummary: GetRecommendationsSummaryResponse = {
  percentageOfTxWithDisplayedRecommendation: 95.51,
  txWithPurchasedRecommendation: {
    total: 375,
    comparedToPreviousMonthPercentage: 21.753246,
  },
  percentageOfTxWherePurchasedRecommendation: 3.28,
  percentageOfRevenueLiftForTxWithPurchasedRecommendation: 15.47,
  revenueAddedThroughRecommendations: {
    total: 1715,
    comparedToPreviousMonthPercentage: 35.334923,
  },
  revenueAddedAfterShowingRecommendations: {
    total: 2064,
    comparedToPreviousMonthPercentage: 42.384045,
  },
};

export const recommendationsTopItems: GetRecommendationsTopItemsResponse = [
  {
    itemName: 'Kettle Chips',
    qty: 2036,
    orders: 1303,
    revenue: 3033.64,
    takeRate: 1.418,
    imageUrl: '',
  },
  {
    itemName: 'Bottled Beverage',
    qty: 1079,
    orders: 8081,
    revenue: 2825.71,
    takeRate: 0.8569,
    imageUrl: '',
  },
  {
    itemName: 'Cookie',
    qty: 1054,
    orders: 757,
    revenue: 3151.46,
    takeRate: 0.9101,
    imageUrl: '',
  },
  {
    itemName: 'Milkshakes',
    qty: 189,
    orders: 163,
    revenue: 1124.55,
    takeRate: 0.8566,
    imageUrl: '',
  },
  {
    itemName: 'Milkshake',
    qty: 141,
    orders: 123,
    revenue: 838.95,
    takeRate: 0.0,
    imageUrl: '',
  },
  {
    itemName: '1/2 Gal Beverages',
    qty: 37,
    orders: 16,
    revenue: 277.53,
    takeRate: 0.0,
    imageUrl: '',
  },
  {
    itemName: 'Pumpkin Bisque',
    qty: 30,
    orders: 28,
    revenue: 194.1,
    takeRate: 0.1459,
    imageUrl: '',
  },
  {
    itemName: 'Dessert Bar',
    qty: 19,
    orders: 9,
    revenue: 61.41,
    takeRate: 0.3447,
    imageUrl: '',
  },
  {
    itemName: 'Additional Chips',
    qty: 19,
    orders: 9,
    revenue: 32.89,
    takeRate: 1.0676,
    imageUrl: '',
  },
  {
    itemName: 'Two Liter Sodas',
    qty: 18,
    orders: 7,
    revenue: 88.5,
    takeRate: 1.1885,
    imageUrl: '',
  },
  {
    itemName: 'Cheddar Broccoli Soup',
    qty: 16,
    orders: 16,
    revenue: 100.4,
    takeRate: 0.9604,
    imageUrl: '',
  },
  {
    itemName: 'Mac & Cheese',
    qty: 14,
    orders: 6,
    revenue: 95.78,
    takeRate: 0.0,
    imageUrl: '',
  },
  {
    itemName: 'Additional Dessert Bars',
    qty: 8,
    orders: 1,
    revenue: 28.0,
    takeRate: 0.4255,
    imageUrl: '',
  },
  {
    itemName: 'Additional Cookies',
    qty: 4,
    orders: 3,
    revenue: 35.0,
    takeRate: 0.3517,
    imageUrl: '',
  },
  {
    itemName: 'Large Panini Pak',
    qty: 2,
    orders: 1,
    revenue: 379.9,
    takeRate: 100.0,
    imageUrl: '',
  },
];

export const recommendationsAverageBasketValue: GetRecommendationsAverageBasketValueResponse =
  [
    {
      date: 1717200000,
      txWithNoRecommendationsPresented: 25.704828,
      txWithRecommendationsPurchased: 31.202831,
      txWithRecommendationsPresentedButNotPurchased: 27.701883,
    },
    {
      date: 1719792000,
      txWithNoRecommendationsPresented: 26.60098,
      txWithRecommendationsPurchased: 32.708393,
      txWithRecommendationsPresentedButNotPurchased: 26.100758,
    },
    {
      date: 1748736000,
      txWithNoRecommendationsPresented: 26.878214,
      txWithRecommendationsPurchased: 59.96,
      txWithRecommendationsPresentedButNotPurchased: 0.0,
    },
    {
      date: 1743465600,
      txWithNoRecommendationsPresented: 26.276764,
      txWithRecommendationsPurchased: 313.9725,
      txWithRecommendationsPresentedButNotPurchased: 134.67249,
    },
    {
      date: 1730419200,
      txWithNoRecommendationsPresented: 18.080795,
      txWithRecommendationsPurchased: 42.927094,
      txWithRecommendationsPresentedButNotPurchased: 31.530613,
    },
    {
      date: 1735689600,
      txWithNoRecommendationsPresented: 23.532507,
      txWithRecommendationsPurchased: 31.773708,
      txWithRecommendationsPresentedButNotPurchased: 28.036482,
    },
    {
      date: 1738368000,
      txWithNoRecommendationsPresented: 25.651962,
      txWithRecommendationsPurchased: 28.42549,
      txWithRecommendationsPresentedButNotPurchased: 29.66087,
    },
    {
      date: 1733011200,
      txWithNoRecommendationsPresented: 13.14,
      txWithRecommendationsPurchased: 28.322313,
      txWithRecommendationsPresentedButNotPurchased: 27.368261,
    },
    {
      date: 1756684800,
      txWithNoRecommendationsPresented: 15.958843,
      txWithRecommendationsPurchased: 30.168701,
      txWithRecommendationsPresentedButNotPurchased: 27.407719,
    },
    {
      date: 1725148800,
      txWithNoRecommendationsPresented: 17.194288,
      txWithRecommendationsPurchased: 30.492344,
      txWithRecommendationsPresentedButNotPurchased: 29.773699,
    },
    {
      date: 1740787200,
      txWithNoRecommendationsPresented: 25.39563,
      txWithRecommendationsPurchased: 34.301785,
      txWithRecommendationsPresentedButNotPurchased: 29.733858,
    },
    {
      date: 1759276800,
      txWithNoRecommendationsPresented: 15.832174,
      txWithRecommendationsPurchased: 35.064907,
      txWithRecommendationsPresentedButNotPurchased: 28.865765,
    },
    {
      date: 1761955200,
      txWithNoRecommendationsPresented: 15.161035,
      txWithRecommendationsPurchased: 35.254444,
      txWithRecommendationsPresentedButNotPurchased: 29.863684,
    },
    {
      date: 1727740800,
      txWithNoRecommendationsPresented: 17.612036,
      txWithRecommendationsPurchased: 35.233555,
      txWithRecommendationsPresentedButNotPurchased: 29.67423,
    },
    {
      date: 1722470400,
      txWithNoRecommendationsPresented: 24.608871,
      txWithRecommendationsPurchased: 34.501587,
      txWithRecommendationsPresentedButNotPurchased: 30.555931,
    },
    {
      date: 1751328000,
      txWithNoRecommendationsPresented: 26.098663,
      txWithRecommendationsPurchased: 61.980625,
      txWithRecommendationsPresentedButNotPurchased: 0.0,
    },
    {
      date: 1746057600,
      txWithNoRecommendationsPresented: 27.434214,
      txWithRecommendationsPurchased: 1065.88,
      txWithRecommendationsPresentedButNotPurchased: 63.83718,
    },
    {
      date: 1754006400,
      txWithNoRecommendationsPresented: 26.588087,
      txWithRecommendationsPurchased: 28.734259,
      txWithRecommendationsPresentedButNotPurchased: 27.142006,
    },
  ];
